<template>
  <div class="list">
    <div class="header" v-if="header != 'none'">
        <div class="header-label">
            Verstuurde Notificaties:
        </div>
        <div class="header-controls">
            <select id="filter" v-model="channel" @change="updateChannel" class="select" title="Kies een kanaal om verstuurde notificaties te filteren">
                <option value="all">Geen filter</option>
                <option :value="key" v-for="(val, key) in channels" :key="key">
                    {{ val }}
                </option>
            </select>
        </div>
    </div>
    <div class="notification" v-for="notification in notifications" :key="notification.id">
        <DisplayNotification
            :notification="notification"
            :channels="channels"
        />
    </div>
    <div class="pagination" v-if="header != 'none'">
        <div class="limit">
            <label for="limit">Aantal: </label>
            <input type="text" id="limit" :value="pagination.limit" @change="updateLimit" placeholder="Hoeveel resultaten wil je zien?">
        </div>
        <div class="page"><span v-if="notifications.length == pagination.limit || pagination.offset > 0">Pagina {{ pageNum }}</span></div>
        <div class="previous" v-if="pagination.offset >= pagination.limit" @click="previous">&lt; Vorige</div>
        <div class="next" v-if="notifications.length == pagination.limit" @click="next">Volgende &gt;</div>
    </div>
  </div>
</template>

<script>
    import DisplayNotification from './DisplayNotification'

    export default {
        props: ['notifications', 'channels', 'header', 'pagination', 'pageNum'],
        components: {
            DisplayNotification
        },
        data: () => ({
            channel: 'all'
        }),
        model: {
            prop: 'pagination',
            event: 'changePagination',
        },
        methods: {
            updateChannel() {
                let channel = ''
                if (this.channel !== 'all') {
                    channel = this.channel
                }
                this.$emit('changePagination', {...this.pagination, channel: channel, offset: 0 })
            },
            updateLimit(e) {
                this.$emit('changePagination', {...this.pagination, limit: e.target.value })
            },
            next() {
                const offset = Number(this.pagination.offset) + Number(this.pagination.limit)
                this.$emit('changePagination', {...this.pagination, offset: offset });
            },
            previous() {
                const offset = Number(this.pagination.offset) - Number(this.pagination.limit)
                this.$emit('changePagination', {...this.pagination, offset: offset });
            }
        },
    };
</script>

<style scoped>
    .list {
        margin-top: 50px;
    }
    .header {
        display: flex;
        align-content: stretch;
    }
    .header-label {
        flex-grow: 1;
    }
    .header-controls {
        font-size: 14px;
    }
    .pagination {
        display: flex;

    }
    .page {
        flex-grow: 1;
        padding: 9px 17px;
        text-align: center;
    }
    .limit input {
        width: 40px;
        margin-bottom: 4px;
        box-sizing: border-box;
        padding: 8px;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        font-size: 16px;
        border: 0px solid silver;
        border-bottom: 1px solid #e0e0e0;
    }
    .previous, .next {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        display: inline-block;
        background-color: white;
        color: black;
        padding: 9px 17px;
        margin: 0px 2px;
        font-size: 14px;
        border: 1px solid #eee;
        border-radius: 4px;
        cursor: pointer;

    }
</style>
